import { gql } from '@apollo/client';

export const GET_TRANSACTION_KPI = gql`
  query GetTransactionKpi($days: Int) {
    getTransactionKpi(days: $days) {
      transaction_totals {
        total_sales
        total_earnings
        total_commission
        total_withdrawal
        total_payment
      }
      customer_payment_stats {
        paying_percentage
        non_paying_percentage
      }
    }
  }
`;
